import React from 'react'

const RacingBall = ({ i,  }) => {

    const colors = [
        {
            id:1,
            color:'#ffe600'
        },
        {
            id:2,
            color:'#0077ff'
        },
        {
            id:3,
            color:'#181818'
        },
        {
            id:4,
            color:'#ff9100'
        },
        {
            id:5,
            color:'#00e1ff'
        },
        {
            id:6,
            color:'#161152'
        },
        {
            id:7,
            color:'#525252'
        },
        {
            id:8,
            color:'#ff4e74'
        },
        {
            id:9,
            color:'#970000'
        },
        {
            id:10,
            color:'#004b25'
        }
    ]

    const color = colors.find((color) => color.id === i)

  return (
    <div className='cursor-pointer racingballContainer flex flex-col justify-center items-center space-y-1 w-auto'>
        <div style={{ '--i':`${color.color}` }} className={` racingball flex justify-center items-center rounded-full w-[35px] h-[35px]`}>
            <p className='z-[1] font-semibold'>{ i }</p>
        </div>  
    </div>
  )
}

export default RacingBall